const results = require("./results.json");

export default {
  results,
};
